import { FC } from 'react';

import './Pill.scss';

export type Props = {
	text?: string;
	color?: string;
};

export const Pill:  FC<Props> = ({text, color}) => {
	return(
		<div className={`c-pill c-pill__${color}`}>
			{text}
		</div>
	);
};

